import { Box, Text, styled } from '@ltvco/refresh-lib/theme';
import { ChevronRight } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

export const BreadcrumbRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(0.25),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0.5),
  },
}));

export const BreadcrumbLink = styled(RouterLink)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: theme.typography.fontWeightRegular ?? 400,
  lineHeight: theme.typography.pxToRem(16.8),
  letterSpacing: 0,
  color: theme.palette.primary.main,
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  '&:hover': {
    textDecoration: 'underline',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.pxToRem(15),
    lineHeight: theme.typography.pxToRem(20),
  },
}));

export const BreadcrumbCurrent = styled(Text)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(14),
  fontWeight: theme.typography.fontWeightRegular ?? 400,
  lineHeight: theme.typography.pxToRem(16.8),
  color: theme.palette.text.secondary,
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.pxToRem(15),
    lineHeight: theme.typography.pxToRem(20),
  },
}));

export const BreadcrumbChevron = styled(ChevronRight)(({ theme }) => ({
  fontSize: 18,
  color: theme.palette.text.disabled,
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    fontSize: 20,
  },
}));
